module.exports = __webpack_public_path__ + "static/media/Group2676.644ee7b8.svg";